import {css} from 'lit'; export default css`.fly-toolbar{z-index:10;--fly-icon-size:32px;padding:12px 24px;display:flex;justify-content:space-between}.fly-toolbar--raised{box-shadow:0 3px 4.5px rgba(79,76,88,.18)}`;
    